import { injectable } from "inversify";
import { action, observable } from "mobx";
import {
  CalendarEventType,
  EventDetailViewType,
} from "../../components/bookings/ScheduleScreen/Calendar/interfaces";
import { IFbTheoryExamEventModel } from "./interfaces";

@injectable()
export class FbTheoryExamEventModel implements IFbTheoryExamEventModel {
  public readonly isTheoryExam = true;
  @observable
  public id!: number;
  @observable
  public location: string = "";
  @observable
  public name: string = "";
  @observable
  public from!: Date;
  @observable
  public to!: Date;
  @observable
  public typeKey!: CalendarEventType;
  public getEventDetailView(): Promise<
    EventDetailViewType<IFbTheoryExamEventModel>
  > {
    return import(
      /* webpackChunkName: "FbTheoryExamEventDetailView" */ "../../components/bookings/EventsListScreen/EventDetails/EventDetailView/FbTheoryExamEventDetailView"
    ).then((res) => res.FbTheoryExamEventDetailView);
  }

  @action
  public setFrom(from: Date): void {
    this.from = from;
  }

  @action
  public setTo(to: Date): void {
    this.to = to;
  }
  @action
  public setName(name: string): void {
    this.name = name;
  }
  @action
  public setTypeKey(typeKey: CalendarEventType): void {
    this.typeKey = typeKey;
  }

  @action
  public setId(id: number): void {
    this.id = id;
  }
  @action
  public setLocation(location: string): void {
    this.location = location;
  }

  public isEditable(): boolean {
    return false;
  }

  public isEditableViaSupport(): boolean {
    return this.from.getTime() > Date.now();
  }
}
